import ModelGalleryButtonContainer from "../../containers/GalleryButtonContainer";
import PublicModelAssetService from "../../services/PublicModelAssetService";

const PublicModelDetailsPageGallery = ({ modelId }: { modelId: string }) => {
  return (
    <ModelGalleryButtonContainer
      modelId={modelId}
      fetchImages={() =>
        PublicModelAssetService.getModelAssets(modelId)
          .then((res) =>
            res.data.map((asset) => ({
              id: asset.id,
              src: asset.url,
              alt: asset.originalName,
              title: asset.originalName,
            }))
          )
          .catch((err) => {
            console.error(err);
            return [];
          })
      }
    />
  );
};

export default PublicModelDetailsPageGallery;
